import SuperRepository from '../superRepository'

export default new class userGroupOrderSettingRepository extends SuperRepository {
  baseUri () {
    return 'user_group_order_setting'
  }
}